/**
 * CommentAnchor
 */

import Config from '../../Config';
import Util from '../../Util';
import { COMMENT_TITLE, COMMENT_ANCHOR } from './CommentHeader';
const onLoadedEnd = ['onCommentLoaded', 'onViewLoaded', 'onSignLoaded'];

let INSTANCE: CommentAnchor = null;
let callCount = 0;

class CommentAnchor {
  private hash: string;
  private hashs: any;

  constructor() {
    if (!INSTANCE) {
      this.hash = Util.getHash();
      this.hashs = this.hash.split('#');
      // this.checkImageLoaded();
      INSTANCE = this;
    }

    return INSTANCE;
  }

  goToComment(onLoaded: any) {
    callCount++;

    const idx = onLoadedEnd.indexOf(onLoaded);

    if (idx !== -1) {
      onLoadedEnd.splice(idx, 1);
    }

    if (!Config.isMyProfile) {
      onLoadedEnd.pop();
    }

    if (onLoadedEnd.length === 0) {
      const selector = `.${COMMENT_TITLE} a[name=${COMMENT_ANCHOR}]`;
      const $anchor = jQuery(selector);

      if (this.hashs.indexOf('comment') !== -1 && $anchor.length) {
        const top = $anchor.offset().top;
        setTimeout(() => {
          jQuery(window).scrollTop(top);
        }, 500);
      }
    }
  }
}

export default CommentAnchor;
